<template>
	<vs-popup
		:title="$t('changeBalance')"
		class="primary-popup set-ticket-failed"
		:active.sync="activeProp"
	>
		<div class="prices__container">
            <div class="vx-row">
                <div v-for="(item, index) in actions" :key="index" class="vx-col">
                    <vs-radio
						v-model="action"
						:vs-value="item.action"
						class="set-ticket-failed__item"
					>{{ getActionName(item.action) }}</vs-radio>
                </div>
            </div>
			<div class="vx-col stage-list__item mt-2">
				<vs-input
					:placeholder="amountToChange"
					v-model="amountToChange"
				/>
			</div>
		</div>
		<div class="set-ticket-failed__controls">
			<vs-button
				:disabled="isDisabled || !action"
				color="primary"
				@click="confirm"
                class="mr-2"
			>{{ $t('save') }}</vs-button>

			<vs-custom-button
				@click="close"
				color="#9a9a9a"
				type="flat"
			>{{ $t('cancel') }}</vs-custom-button>
		</div>
	</vs-popup>
</template>

<script>

export default {
	name: "ChangePriceForAuthor",
	props: {
		active: 		{ default: false, type: Boolean },
	},
	data() {
		return {
			isDisabled: true,
			amountToChange: '0',
            action: null
		}
	},
	watch: {
		activeProp(newValue) {
			if(newValue === false) {
                this.amountToChange = ''
                this.action = null
			}
		},
		amountToChange(val) {
			this.validate(val)
		},
	},
	computed: {
        actions() {
            return [
                { action: 'in' },
                { action: 'out' },
            ]
        },
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		}
	},
	methods: {
        getActionName(action) {
            if (action === 'in') return this.$t('balanceIn')
            return this.$t('balanceOut')
        },
		validate(price) {
            this.amountToChange = price.replace(/\D/g,'')

			if (price <= 0 || isNaN(price)) {
				this.isDisabled = true;
			} else {
				this.isDisabled = false;
			}

		},
		confirm() {
			this.$emit("confirm", this.action, this.amountToChange);
			this.activeProp = false;
		},
		close() {
			this.activeProp = false;
		}
	},
	
}
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.set-ticket-failed {
	&__title {
		padding-left: 8px;
		padding-right: 8px;
	}

	&__list {
		padding-left: 8px;
		padding-right: 8px;
		margin-top: 7px;
	}

	&__item {
		margin-top: 5px;
	}

	&__controls {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.vs-popup {
		max-width: 350px !important;
		width: 100% !important;
		padding: 0;

		&--content {
			width: 100%;
			height: 100%;
            overflow: hidden;
		}

		&--close,
		&--title h3 {
			color: $primary;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			padding-top: 15px;
		}
		.prices__container {
			display: flex;
			flex-direction: column;
            .vs-con-input-label {
                width: 100%;
            }
		}
	}
}
</style>
